import { render, staticRenderFns } from "./agentApply.vue?vue&type=template&id=567a9852&scoped=true&"
import script from "./agentApply.vue?vue&type=script&lang=js&"
export * from "./agentApply.vue?vue&type=script&lang=js&"
import style0 from "./agentApply.vue?vue&type=style&index=0&id=567a9852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a9852",
  null
  
)

export default component.exports